import type { ReactNode } from 'react';

/**
 * Theme is fixed in styles/tokens.css (saas-platform navy/cyan).
 * Provider kept for mount-tree compatibility; no runtime CSS overrides.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return children;
}
